module.exports = __webpack_public_path__ + "static/img/cit_bg_h5.64a6069.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/cit_bg_h5.png
// module id = 4o5F
// module chunks = 34